import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

// SalesAgentSelector — controls Itinerary.sales_agent_email, the agent who
// SOLD the trip. This is what feeds Sofi's "agente de ventas" dropdown on
// push. Defaults to whoever created the itinerary, but any agent can
// reassign it: the admin often imports or builds the trip on behalf of the
// agent who closed the sale (2026-09-18).
export function SalesAgentSelector({ itn, setField }) {
  const [agents, setAgents] = useState([]);
  useEffect(() => {
    api.get("/agents/list", { params: { include_self: true } })
      .then(({ data }) => setAgents(data.agents || []))
      .catch(() => setAgents([]));
  }, []);

  const current = (itn.sales_agent_email || itn.created_by || "").toLowerCase();
  const selected = agents.find((a) => a.email === current);
  // No mapping in Sofi → the push can't select anybody and Sofi falls back
  // to the logged-in account. Warn before the agent finds out in Sofi.
  const noSofi = !!selected && selected.sofi_agent_id == null;

  return (
    <div className="flex items-center gap-1.5">
      <select
        data-testid="sales-agent"
        value={current}
        onChange={(e) => setField("sales_agent_email", e.target.value)}
        className="w-full bg-transparent outline-none text-sm cursor-pointer"
        title="Agente que ha vendido el viaje · es el «agente de ventas» que se envía a Sofi"
      >
        {current && !selected && <option value={current}>{current}</option>}
        {agents.map((a) => (
          <option key={a.email} value={a.email}>{a.name}</option>
        ))}
      </select>
      {noSofi && (
        <span
          data-testid="sales-agent-no-sofi"
          title="Este agente no está mapeado en Sofi: al enviar el viaje, Sofi pondrá al usuario con el que entra la app."
          className="text-amber-600 shrink-0"
        >
          <AlertTriangle size={12} />
        </span>
      )}
    </div>
  );
}
